<template>
	<div class="cart-item d-flex align-items-start">
		<img
			:src="item.attributes.thumbnail + '?w=130&h=130&fit=crop'"
			:alt="item.name"
			v-if="item.attributes.thumbnail"
		/>
		<img src="../assets/img/placeholder.svg" :alt="item.name" v-else />
		<div class="flex-grow-1 pr-3">
			<h4 class="mb-1 mt-0">{{ item.quantity }} x {{ item.name }}</h4>
			<span v-if="item.attributes.staff_id"
				>Personeelsnummer: {{ item.attributes.staff_id }}</span
			>

			<ul class="list-group pt-3" v-if="item.files">
				<li
					class="list-group-item py-2 px-3 d-flex justify-content-between"
					v-for="(file, fileIndex) in item.files"
					:key="file.id"
				>
					<span>{{ file.name }}</span>
					<a
						href="#"
						@click.prevent="deleteFile(file, fileIndex)"
						class="href"
					>
						<i class="fa fa-times"></i>
					</a>
				</li>
			</ul>

			<div class="mt-2">
				<a
					href="#"
					class="btn btn--sm btn--accent"
					@click.prevent="enableUpload = true"
					v-if="!enableUpload"
					>Bestanden toevoegen</a
				>
				<div v-else>
					<vue-dropzone
						ref="dz"
						id="dropzone"
						:options="dropzoneOptions"
						@vdropzone-complete="fileUploaded"
						@vdropzone-sending="fileSending"
					></vue-dropzone>
				</div>
			</div>
		</div>
		<div>
			<input
				type="number"
				class="form-control"
				min="1"
				v-model="item.quantity"
				@blur="updateItem"
			/>
		</div>
		<a href="#" class="remove mt-1 ml-3" @click.prevent="removeItem">
			<i class="fa fa-times"></i>
		</a>
	</div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
	props: ['item', 'index'],
	components: {
		vueDropzone: vue2Dropzone,
	},
	data() {
		return {
			enableUpload: false,
			dropzoneOptions: {
				url: process.env.VUE_APP_BASE_API_URL + '/attachments',
				thumbnailWidth: 150,
				maxFilesize: 5,
				headers: {
					Authorization: 'Bearer ' + this.$store.getters.token,
				},
			},
		}
	},
	methods: {
		updateItem() {
			this.$http
				.put('/cart/items/' + this.item.id, {
					quantity: this.item.quantity,
				})
				.then((res) => {
					console.log(res)
				})
				.catch((err) => {
					console.log(err)
				})
		},

		removeItem() {
			this.$http
				.delete('/cart/items/' + this.item.id)
				.then((res) => {
					this.$emit('removed')
					this.$root.$emit('cart-changed')
				})
				.catch((err) => {
					console.log(err)
				})
		},
		fileUploaded(file) {
			console.log(file)
		},
		fileSending(file, xhr, formData) {
			formData.append('item_id', this.item.id)
		},
		fileSelected(file) {
			this.$emit('file-selected', file)
		},
		deleteFile(file, index) {
			if (
				window.confirm(
					'Bent u zeker dat u deze bijlage wil verwijderen? Dit is een actie die niet ongedaan kan gemaakt worden.',
				)
			) {
				this.$http
					.delete(
						'/cart/items/' +
							this.item.id +
							'/attachments/' +
							file.id,
					)
					.then((res) => {
						console.log(res)
						this.item.files.splice(index, 1)
					})
					.catch((err) => {
						console.log(err)
					})
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.cart-item {
	img {
		height: 65px;
		width: 65px;
		border: 1px solid $border;
		min-width: 65px;
		margin-right: 15px;
	}

	.form-control {
		width: 60px;
		text-align: center;
	}

	.remove {
		color: $primary;
		display: block;
		text-decoration: none !important;
	}
}
</style>
